import React from "react";
import styled from "styled-components";
import { Stack } from "react-bootstrap";
import { useMemo } from "react";
import { NotaCredito } from "../../services/ventasServicios";
import { dateCompareStr } from "../../utils/dateUtils";
import TableTitle from "../organisms/TableTitle";
import NotasCreditoTable from "./NotasCreditoTable";

function NotasCreditoTableSection({ notasCredito }: { notasCredito: NotaCredito[] }) {
  const items = useMemo(() => {
    let devolucionesOrdenadas = notasCredito;
    devolucionesOrdenadas.sort((itemA, itemB) => {
      return dateCompareStr(itemA.fecha, itemB.fecha);
    });
    return devolucionesOrdenadas;
  }, [notasCredito]);

  if (notasCredito.length === 0) {
    return <></>;
  }

  return (
    <ResponsiveTableSection>
      <TableTitle>{"Notas Crédito"}</TableTitle>
      <TableWrapper>
        <Stack gap={4}>
          <NotasCreditoTable items={items} />
        </Stack>
      </TableWrapper>
    </ResponsiveTableSection>
  );
}

const ResponsiveTableSection = styled("div")`
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const TableWrapper = styled("div")`
  position: relative;
  clear: both;
  zoom: 1;
`;

export default NotasCreditoTableSection;
